"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListener = void 0;
const react_1 = require("react");
const useListener = () => {
    const listener = (0, react_1.useRef)(null);
    const listen = (0, react_1.useCallback)((event, callback) => {
        window.removeEventListener(event, listener.current);
        listener.current = ((params) => callback && callback(params));
        window.addEventListener(event, listener.current);
    }, []);
    return (0, react_1.useMemo)(() => ({ listen }), [listen]);
};
exports.useListener = useListener;
//# sourceMappingURL=useListener.js.map